import React from "react";
import { ReactBarcode } from "react-jsbarcode";

// Pharmaceutical industry ke liye bana hai, Sirf numbers support karta hai, Chhoti information encode karta hai. 👇
// format: "pharmacode",
// (Most Common) Letters + Numbers dono support karta hai. 👇
// format: "CODE128",

const BarcodeGenerator = ({ textValue }) => {
  return (
    <ReactBarcode
      value={String(textValue ?? "")}
      options={{
        format: "CODE128",
        lineColor: "#0aa",
        width: 1.3,
        height: 20,
        displayValue: true,
      }}
      renderer="svg"
    />
  );
};
export default BarcodeGenerator;
